module.exports = __webpack_public_path__ + "static/media/vehicle-grey.b20c2d4f.svg";